<div class="units">
  <div class="unit-selections-2 single">
    @if (favorite_selection) {
      <div class="unit-item-2 racing">
        <div class="racing-content-left">
          <i class="favorite-icon cb-icon-star-outline racing-silk-preview"></i>
          <div class="breakdown-score-2">
            <span [transloco]="'racing.FAVORITE'"></span>
          </div>
        </div>
        <div class="breakdown-units-2">
          @if (favorite_selection.unit_distributions.length <= 0) {<span> - </span>}
          @if (favorite_selection.unit_distributions.length > 0) {
            <span class="mr-0.5">{{favorite_selection.unit_distributions[0].units | formatUnits }}</span>
            @if (favorite_selection.unit_distributions[0].units != 0) {
              <span [transloco]="'poolUnitsDist.UNIT'"></span>
            }
          }
        </div>
      </div>
    }

    @for (competitor of competitors | orderBy:'cloth_number'; track $index; let i = $index) {
      <div class="unit-item-2 racing">
        <div class="racing-content-left">
          @if (!competitor.withdrawn) {
            <img class="racing-silk-preview dogs" loading="lazy"
                 [src]="imagesUrl + '/assets/images/greyhounds/position_' + competitor.cloth_number + '.png'"
                 alt="{{competitor.cloth_number}}"/>
          }
          @if (competitor.withdrawn) {
            <div class="racing-silk-preview">
              <span [transloco]="'racing.NON_RUNNER'"></span>
            </div>
          }
          <div class="breakdown-score-2">
            {{competitor.name}}
          </div>
        </div>
        <div class="breakdown-units-2">
          @if (competitor.selection.unit_distributions.length <= 0) {<span> - </span>}
          @if (competitor.selection.unit_distributions.length > 0) {
            <span class="mr-0.5">{{competitor.selection.unit_distributions[0].units | formatUnits }}</span>
            @if (competitor.selection.unit_distributions[0].units != 0) {
              <span [transloco]="'poolUnitsDist.UNIT'"></span>
            }
          }
        </div>
      </div>
    }
  </div>
</div>
